import { reduce } from 'lodash';

import './word-switcher.style.sass';
import template from './word-switcher.tpl.pug';

class WordSwitcherController {
    /* @ngInject */
    constructor($interval) {
        this.$interval = $interval;
    }

    $onInit() {
        this.index = 0;

        this.id = this.$interval(this.selectNext.bind(this), this.interval);
    }

    $onDestroy() {
        this.$interval.cancel(this.id);
    }

    $onChanges(changeObject) {
        if (changeObject.words) {
            this.word = reduce(this.words || [], (longest, word) => {
                return !longest || longest.length < word.length ? word : longest;
            }, null);
        }
    }

    selectNext() {
        this.leave = this.index;
        this.index = (this.index + 1) % this.words.length;
        this.enter = this.index;
    }
}

export default {
    selector: 'dbPWordSwitcher',
    template: template(),
    controller: WordSwitcherController,
    bindings: {
        words: '<',
        interval: '<'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/component/word-switcher/word-switcher.cmpt.js